const passiveEvents = (() => {
  let pa = false;
  try {
    const opts = Object.defineProperty({}, 'passive', {
      get() {
        pa = true;
        return undefined;
      },
    });
    window.addEventListener('testPassive', null, opts);
    window.removeEventListener('testPassive', null, opts);
  } catch (e) {
    // ignore
  }

  return pa;
})();

export default passiveEvents;



// WEBPACK FOOTER //
// ./src/scripts/utils/passive-events.js